import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

export default function ProfilePhoto(props) {
    return (
        <Grid item sx={{ display: "flex", "& > *": { margin: 1, cursor: "pointer" } }}>
            <Avatar src={props.photo} alt={props.alt} sx={{ width: 160, height: 160 }} />
        </Grid>
    );
}
